export default __webpack_public_path__ + "static/experince-48477d4eea132245e44f87befb9900db.png";